import { render, staticRenderFns } from "./CarUpdate.vue?vue&type=template&id=b6cc59f2"
import script from "./CarUpdate.vue?vue&type=script&lang=ts"
export * from "./CarUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports